import * as React from 'react';
import Div from "@jumbo/shared/Div";
import { Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useLocation } from "react-router-dom";
import SnK from 'app/components/Modal/SnK';
import { setupParams } from 'app/services/setupWebview';
import Swal from 'sweetalert2';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { isMobile } from 'react-device-detect';
import { useProgram } from 'app/hooks/useProgram';

const WebViewLogin = () => {
	const [params, setParams] = React.useState(null);

	// Hooks
	const location = useLocation();

	const program = useProgram();

	const navigate = useNavigate();

	// State
	const [openSnK, setOpenSnk] = React.useState(false);
	const [canContinue, setCanContinue] = React.useState(true);

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// } else {
		if (!params) {
			setupParams(location.search, setParams, true, errorCallback)
		}
		// }
	}, []);

	const errorCallback = (errMsg) => {
		setCanContinue(false)

		localStorage.removeItem('params')
		localStorage.removeItem('restartAvailableTime')
		localStorage.removeItem('expiryTime')
		localStorage.removeItem('restartCount')
		// setIsNext(false)
		Swal.fire({
			icon: 'warning',
			// text: 'Mohon periksa kembali URL yang anda masukan',
			text: errMsg,
			allowOutsideClick: false,
			confirmButtonText: 'Kembali',
			confirmButtonColor: 'red'
		}).then(() => {
			try {
				localStorage.removeItem('agentCode')
				localStorage.removeItem('token')
				window.ReactNativeWebView.postMessage(JSON.stringify('exit webview'));
			} catch (error) {
				console.log(error)
			}
		})
	}

	const nextPage = () => {
		navigate('/webViewRegistrasi');
	};

	const handleClickOpenSnk = (scrollType) => () => {
		// if (setIsNext) {
		setOpenSnk(true);
		// } else {
		// 	errorCallback()
		// }
		// // setScroll(scrollType);
	};

	const exitWebView = () => {
		localStorage.removeItem('agentCode')
		localStorage.removeItem('token')
		window.ReactNativeWebView.postMessage(JSON.stringify('exit webview'));
	};

	return (
		<Div className='page-wrapper-mobile login'>
			<Div
				sx={{
					minWidth: 64,
					height: 64,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					position: 'fixed',
					left: 0,
					top: 0
				}}>
				<IconButton
					onClick={exitWebView} sx={{
						height: 24,
						width: 24,
						borderRadius: 100,
						backgroundColor: "#FFFFFF",

						'&:hover': {
							backgroundColor: '#FFFFFF'
						}
					}}>
					<NavigateBeforeIcon sx={{ color: "#C21B17" }} />
				</IconButton>
			</Div>

			<Div sx={{
				p: '40px 24px',
				flex: 1,
				alignItems: 'center',
				justifyContent: 'center',
				display: 'flex'
			}}>
				<img alt="logo-generali.png" src={`${process.env.REACT_APP_IMAGES_PATH}/logo-generali.png`} width={120} height={97} />
			</Div>
			<Div sx={{
				backgroundColor: '#ffffff',
				borderRadius: '20px 20px 0 0',
				padding: '24px 24px 34px',
				width: '100%'
			}}>
				<Typography variant={"h3"} fontWeight={600} mb={1} color={"#C21B17"}>{program}</Typography>
				<Typography fontSize={14} fontWeight={400} mb={1}>Selamat datang di “{program}” Generali Indonesia. Program ini bertujuan untuk membantu dalam memperbesar bisnis anda melalui jaringan yang anda miliki.</Typography>
				<Div sx={{ mt: 3 }}>
					<Typography fontSize={10} fontWeight={400} mb={1}>*Silakan klik tombol Registrasi di bawah ini untuk mengikuti {program}.</Typography>

					<ButtonStyled
						disabled={!canContinue}
						btnText={"Registrasi"}
						preset={"primary"}
						onClick={handleClickOpenSnk('paper')}
					/>
				</Div>
			</Div>

			<SnK openSnK={openSnK} program={program} setOpenSnk={setOpenSnk} callbackFx={nextPage} params={params} />
		</Div>
	);
};

export default WebViewLogin;